import { render, staticRenderFns } from "./ResponsibleFields.vue?vue&type=template&id=bbab5a64&"
import script from "./ResponsibleFields.vue?vue&type=script&lang=js&"
export * from "./ResponsibleFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports